import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
/* import { Link } from 'react-router-dom'; */
import { withAppContext } from 'apps/ask/contexts/app';

import SupportedConditions from 'apps/ask/components/sections/SupportedConditions';
import CTAGetStarted from 'apps/ask/components/cta/GetStarted';
import ImageUploader from 'apps/ask/components/ImageUploader';

/* import MDAndersonLogo from 'images/ask/logos/mdanderson.png';
 * import StanfordLogo from 'images/ask/logos/stanford.png';
 * import SanovaLogo from 'images/ask/logos/sanova.png';
 * import SunnybrookLogo from 'images/ask/logos/sunnybrook.png';
 * import KaiserLogo from 'images/ask/logos/kaiser.png';
 * import UCLALogo from 'images/ask/logos/ucla.png';
 * import ArrowIcon from 'images/ask/icons/arrow-01.svg';
 * import CheckmarkIcon from 'images/ask/icons/check.svg'; */

import SolutionClinicalImage from 'images/ask/solutions/solution-clinical.png';
import SolutionDermoscopyImage from 'images/ask/solutions/solution-dermoscopy.png';
//import SolutionHeatmapsImage from 'images/ask/solutions/solution-heatmaps.png';


const conditions = [
  'Acne',
  'Atopic eczema',
  'Contact eczema',
  'Psoriasis',
  'Rosacea',
  'Pityriasis rosea',
  'Lichen planus',
  'Tinea corporis',
  'Tinea pedis',
  'Impetigo',
  'Herpes',
  'Shingles',
  'Common warts',
  'Genital warts',
  'Molluscum contagiosum',
  'Scabies',
  'Insect bites',
  'Basal cell carcinoma',
  'Squamous cell carcinoma',
  'Cellulitis',
  'Actinic keratosis',
  'Seborrheic keratosis',
  'Hemangioma',
  'Melanocytic nevus',
  'Non-scaring alopecia',
  'Cicatricial alopecia',
  'Vitiligo',
  'Paronychia',
  'Ulcers',
  'And more...'
];

class ClinicalSolutions extends PureComponent {
  render() {
    return (
      <div className="clinical-solutions-view">
        <section className="hero">
          <div className="container">
            <h1>Clinical Solutions</h1>

            <p>
              Triage offers breakthrough artificial intelligence for
              dermatology that improves workflows and health outcomes.
              Screen more patients and detect disease faster.
            </p>

            <ImageUploader
              className="button button--gradient button--large"
              label="Start your scan"
              onUpload={this.onImageUpload.bind(this)}
            />
          </div>
        </section>

        <section className="solutions">
          <h2>
            Put your practice<br/>
            on autopilot
          </h2>

          <div className="solutions__content">
            <div className="solution">
              <div className="solution__content">
                <span className="solution__label">PHOTOS</span>
                <h3 className="solution__title">
                  Empower your team to triage skin cases
                </h3>
                <p className="solution__text">
                  Screen for over 500 skin disorders using AI. Snap a
                  photo to instantly build an accurate differential
                  diagnosis. Supports everything from common rashes
                  and lesions to rare diseases and cancers.
                </p>
                <ImageUploader
                  className="button button--gradient button--large"
                  label="Start your scan"
                  onUpload={this.onImageUpload.bind(this)}
                />
              </div>
              <img src={SolutionClinicalImage} />
            </div>

            <div className="solution">
              <div className="solution__content">
                <span className="solution__label">DERMOSCOPY</span>
                <h3 className="solution__title">
                  Dermatology meets machine learning
                </h3>
                <p className="solution__text">
                  Our clinical algorithm has been trained to detect
                  cancers in dermoscopic images. Upload a photo or
                  attach a dermatoscope to your smartphone or tablet
                  for instant answers about suspicious lesions.
                </p>
                <ImageUploader
                  className="button button--gradient button--large"
                  label="Start your scan"
                  onUpload={this.onImageUpload.bind(this)}
                />
              </div>
              <img src={SolutionDermoscopyImage} />
            </div>

            {/* <div className="solution">
              <div className="solution__content">
                <span className="solution__label">HEATMAPS</span>
                <h3 className="solution__title">
                  See what you couldn’t before
                </h3>
                <p className="solution__text">
                  Triage provides interpretability by creating
                  personalized heatmaps for every scan, helping you
                  analyze lesions and detect problem areas faster.
                </p>
                <ImageUploader
                  className="button button--gradient button--large"
                  label="Start your scan"
                  onUpload={this.onImageUpload.bind(this)}
                />
              </div>
              <img src={SolutionHeatmapsImage} />
            </div> */}
          </div>
        </section>

        {/* <section className="practices-using-triage">
            <div className="container">
            <h2>You’re in good company.</h2>

            <div className="description">
            <h3>Practices using Triage clinical</h3>
            </div>

            <div className="logos">
            <a href="https://www.sanovadermatology.com" target="_blank" rel="noopener noreferrer">
            <img src={SanovaLogo} alt="Sanova Dermatology" />
            </a>
            <a href="https://www.mdanderson.org" target="_blank" rel="noopener noreferrer">
            <img src={MDAndersonLogo} alt="MDAndreson Cancer Network" />
            </a>
            <a href="https://med.stanford.edu" target="_blank" rel="noopener noreferrer">
            <img src={StanfordLogo} alt="Stanford Medicine" />
            </a>
            <a href="https://www.uclahealth.org" target="_blank" rel="noopener noreferrer">
            <img src={UCLALogo} alt="UCLA Health" />
            </a>
            <a href="https://healthy.kaiserpermanente.org" target="_blank" rel="noopener noreferrer">
            <img src={KaiserLogo} alt="Kaiser Permanente" />
            </a>
            <a href="https://sunnybrook.ca" target="_blank" rel="noopener noreferrer">
            <img src={SunnybrookLogo} alt="Sunnybrook Health Sciencies Centre" />
            </a>
            </div>
            </div>
            </section> */}

        <SupportedConditions
          conditions={conditions}
          title="Our supported conditions"
        />

        {/* <section className="choose-plan">
            <div className="container">
            <h2>
            <img src={CheckmarkIcon} />
            Choose the right plan for you
            </h2>
            <p>
            Triage offers multiple plan types ranging from single use, value pack, or referral programs.
            </p>
            <Link to="/plans" className="link-with-icon">
            <span>Read more</span>
            <img src={ArrowIcon} />
            </Link>
            </div>
            </section> */}

        <CTAGetStarted />
      </div>
    );
  }

  onImageUpload(image) {
    this.props.app.onImageUpload(image);
  }
}

ClinicalSolutions.defaultProps = {};

ClinicalSolutions.propTypes = {
  app: PropTypes.object.isRequired
};

export default withAppContext(ClinicalSolutions);
